module.exports = __webpack_public_path__ + "static/media/post-img3.6d3583ad.jpg";